// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__8VbiD","footerText":"Footer_footerText__MO4mL","footerLinksContainer":"Footer_footerLinksContainer__tIref"};